import {
  FieldError as AriaFieldError,
  type FieldErrorProps,
} from "react-aria-components";

import type { IcIcon } from "@jetblue/kit-icons/types";
import { IcError } from "@jetblue/kit-icons/ic-error";
import { cn } from "../../utilities/tailwind";

export type FieldErrorProperties = {
  Icon?: IcIcon | undefined;
  children?: FieldErrorProps["children"];
  className?: string | undefined;
  iconClassName?: string | undefined;
};
export const FieldError = ({
  Icon = IcError,
  children,
  className = "",
  iconClassName = "",
  ...properties
}: FieldErrorProperties) => (
  <AriaFieldError
    className={cn(
      "mt-1 flex min-h-5 flex-row items-start text-s-body text-red data-[dark-bg=true]:text-white",
      className,
    )}
    {...properties}
  >
    {(properties) => {
      if (!properties.isInvalid) {
        return;
      }
      return (
        <>
          <Icon
            className={cn("my-0.5 me-1 size-3.5 shrink-0", iconClassName)}
          />
          {typeof children === "function" ? children(properties) : children}
        </>
      );
    }}
  </AriaFieldError>
);
FieldError.displayName = "FieldError";
